import { useEffect, useState } from "react";

interface WysiwygEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

// Dynamically load ReactQuill on client to avoid SSR/bundling issues
export default function WysiwygEditor({ value, onChange, placeholder, className }: WysiwygEditorProps) {
  const [QuillComp, setQuillComp] = useState<any>(null);

  useEffect(() => {
    let mounted = true;
    // Load css once
    import("@/assets/react-quill.css").catch(() => {});
    // Dynamic import of react-quill
    import("react-quill").then((mod) => {
      if (mounted) setQuillComp(() => mod.default);
    }).catch((e) => {
      console.error("Failed to load react-quill:", e);
    });
    return () => { mounted = false; };
  }, []);

  if (!QuillComp) {
    // Fallback minimal textarea while editor loads
    return (
      <textarea
        className={`w-full min-h-[160px] rounded-md border p-3 ${className || ""}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  return (
    <QuillComp
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  );
}
